/* eslint-disable @typescript-eslint/no-empty-interface, jsx-a11y/click-events-have-key-events,
 react/no-unstable-nested-components,
 jsx-a11y/no-static-element-interactions */

import React, { useState } from 'react';
import { Search, Table } from 'src/components';
import { Button, Paper } from '@mui/material';
import { AddUserIcon, EditIcon } from 'src/icons';
import { createColumnHelper } from '@tanstack/react-table';
import { RowHover } from 'src/components/Table';
import debounce from 'src/utils/Debounce';
import { JobTitle, CandidateJobTitlesViewRendererProps } from '../../types';

interface ActionDivProps {
  onEdit: (data: JobTitle) => void;
  info: JobTitle,
}

const ActionDiv = function addAction(actionProps: ActionDivProps) {
  const { onEdit, info } = actionProps;
  return (
    <div className="flex flex-row justify-center items-center gap-2">
      <div onClick={() => onEdit(info)}>
        <EditIcon />
      </div>
    </div>
  );
};

function Desktop(props: CandidateJobTitlesViewRendererProps) {
  const {
    jobTitlesFetching,
    filterJobTitles,
    showCreateJobTitle,
    onEditRow,
    onChange,
  } = props;

  const debouncedSearch = debounce(onChange, 100);
  const columnHelper = createColumnHelper<JobTitle>();
  const [rowHover, setRowHover] = useState<RowHover>({});

  const columns = [
    columnHelper.accessor('id', {
      header: () => '',
      cell: () => <div className="px-2" />,
    }),
    columnHelper.accessor('id', {
      header: () => 'S.No',
      cell: (info) => (info.row.index + 1),
    }),
    columnHelper.accessor('value', {
      header: () => 'Name',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('id', {
      header: () => '',
      cell: (info) => (
        <div className="flex justify-center items-center min-w-[100px] min-h-[40px]">
          {
               rowHover[info.row.index]
               && (
                 <ActionDiv
                   info={info.row.original}
                   onEdit={onEditRow}
                 />
               )
             }
        </div>
      ),
    }),
  ];

  const onRowHover = (data: RowHover) => {
    setRowHover(data);
  };

  const onSearchChange = (data: string) => {
    debouncedSearch(data);
  };

  return (
    <>
      <div className="mt-[2%] flex gap-2 flex-row w-[458px]">
        <Search placeholder="Search" onChange={onSearchChange} />
        <div className="w-[176px]">
          <Button variant="contained" fullWidth startIcon={<AddUserIcon />} className="h-[40px] font-medium whitespace-nowrap" onClick={showCreateJobTitle} size="small">Add New Job Title</Button>
        </div>
      </div>
      <Paper className="flex items-center justify-center my-[2%] mt-3 default-shadow-table w-[458px]">
        <Table onRowHover={onRowHover} loading={jobTitlesFetching} data={filterJobTitles} columns={columns} title="List of Job Titles" />
      </Paper>
    </>

  );
}

export default Desktop;
